import { RadioGroup } from '@mui/material';
import styled from 'styled-components';

export const StyledRadioGroup = styled(RadioGroup)<{ $gap?: string }>`
  gap: ${({ $gap }) => $gap ?? '10px 60px'};
`;
